import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Cookie } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const TXT = {
  it: {
    text: 'Questo sito usa cookie tecnici e, solo con il tuo consenso, cookie di terze parti (Google Maps) e analytics (Google Analytics). Puoi accettare o rifiutare.',
    accept: 'Accetta',
    decline: 'Rifiuta',
  },
  en: {
    text: 'This site uses technical cookies and, only with your consent, third-party cookies (Google Maps) and analytics cookies (Google Analytics). You can accept or decline.',
    accept: 'Accept',
    decline: 'Decline',
  },
  es: {
    text: 'Este sitio utiliza cookies técnicas y, solo con tu consentimiento, cookies de terceros (Google Maps) y de análisis (Google Analytics). Puedes aceptarlas o rechazarlas.',
    accept: 'Aceptar',
    decline: 'Rechazar',
  },
  de: {
    text: 'Diese Website verwendet technische Cookies und, nur mit Ihrer Einwilligung, Cookies von Drittanbietern (Google Maps) sowie Analyse-Cookies (Google Analytics). Sie können akzeptieren oder ablehnen.',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
  },
};

export default function CookieBanner() {
  const { lang } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('g28-cookie-consent')) setShow(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem('g28-cookie-consent', value);
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: value === 'accepted' ? 'granted' : 'denied',
        ad_storage: value === 'accepted' ? 'granted' : 'denied',
      });
    }
    setShow(false);
  };

  const t = TXT[lang] || TXT.it;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: 1 }}
          className="fixed bottom-0 inset-x-0 z-[70] bg-emerald-deep text-ivory border-t border-ivory/10"
        >
          <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center gap-4 justify-between">
            <p className="text-sm text-ivory/80 flex items-start sm:items-center gap-3">
              <Cookie size={18} className="text-terracotta shrink-0 mt-0.5 sm:mt-0" />
              {t.text}
            </p>
            <div className="flex gap-3 shrink-0">
              <button
                data-testid="cookie-accept"
                onClick={() => choose('accepted')}
                className="rounded-full bg-terracotta text-emerald-ink px-6 py-2.5 text-sm font-medium transition-colors duration-300 hover:bg-ivory"
              >
                {t.accept}
              </button>
              <button
                data-testid="cookie-decline"
                onClick={() => choose('declined')}
                className="rounded-full border border-ivory/30 text-ivory px-6 py-2.5 text-sm transition-colors duration-300 hover:border-terracotta hover:text-terracotta"
              >
                {t.decline}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
